import React, { Suspense } from 'react';
import FrontendVersionProvider from './contexts/FrontendVersionProvider';
import './App.css';
import "./timeline.css";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HeaderLayout from './components/layout/HeaderLayout';
import {
  forgotPasswordPage,
  guestPage,
  knowledgeBaseListPage,
  loginPage,
  knowledgeBaseArticlePage,
  reservationsPage,
  settingsPage,
  paymentsPage,
  floorPlanDesignerPage,
  reservationTimeTablePage,
  reservationTablePlanPage,
  giftcardPage,
  groupReservationPage,
  waitlistPage,
  groupReservationEditPage,
  printPage,
  statisticsPage,
  monthlySummary,
  registrationPage,
  eventReservationsPage
} from './config/routeConfig';
import "flatpickr/dist/themes/light.css";
import './calendar.css';
import './i18n';
import { AuthProvider } from './contexts/AuthContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import TitleContext from './contexts/TitleContext';
import { NavBadgeProvider } from './contexts/NavBadgeContext';
import { RoomProvider } from './contexts/RoomContext';
import BigLoader from './components/table/BigLoader';
import { GAProvider } from './contexts/GAContext';
import { ProtectedLayout } from './components/layout/ProtectedLayout';
import MobileAppBanner from './components/layout/MobileAppBanner';

function App() {
  const KnowledgebaseListPage = React.lazy(() => import("./pages/KnowledgebaseListPage"))
  const KnowledgebaseArticlePage = React.lazy(() => import("./pages/KnowledgebaseArticlePage"))
  const LoginPage = React.lazy(() => import("./pages/LoginPage"))
  const GuestPage = React.lazy(() => import("./pages/GuestPage"))
  const ForgotPasswordPage = React.lazy(() => import("./pages/ForgotPasswordPage"))
  const ReservationsPage = React.lazy(() => import("./pages/ReservationsPage"))
  const SettingsPage = React.lazy(() => import("./pages/SettingsPage"))
  const PaymentsPage = React.lazy(() => import("./pages/PaymentsPage"))
  const FloorplanDesignerPage = React.lazy(() => import("./pages/FloorplanDesignerPage"))
  const ReservationTimeTablePage = React.lazy(() => import("./pages/ReservationTimeTablePage"))
  const ReservationTablePlanPage = React.lazy(() => import("./pages/ReservationTablePlanPage"))
  const GiftcardPage = React.lazy(() => import("./pages/GiftcardPage"))
  const GroupReservationPage = React.lazy(() => import("./pages/GroupReservationPage"))
  const GroupReservationEditPage = React.lazy(() => import("./pages/GroupReservationEditPage"))
  const WaitlistPage = React.lazy(() => import("./pages/WaitlistPage"))
  const PrintPage = React.lazy(() => import("./pages/PrintPage"))
  const StatisticsPage = React.lazy(() => import("./pages/StatisticsPage"))
  const MonthlySummaryPage = React.lazy(() => import("./pages/MonthlySummaryPage"))
  const NotFound = React.lazy(() => import("./pages/NotFound"))
  const RegistrationPage = React.lazy(() => import("./pages/RegistrationPage"))
  const EventReservationsPage = React.lazy(() => import("./pages/EventReservationsPage"))

  return (
    <BrowserRouter>
      <MobileAppBanner />
      <Suspense fallback={<BigLoader />}>
        <FrontendVersionProvider>
          <GAProvider>
            <SnackbarProvider>
              <AuthProvider>
                <TitleContext>
                  <NavBadgeProvider>
                    <Routes>
                      <Route path={loginPage.path} element={<LoginPage />} />
                      <Route path={forgotPasswordPage.path} element={<ForgotPasswordPage />} />
                      <Route path={registrationPage.path} element={<RegistrationPage />} />
                      <Route element={<HeaderLayout />}>
                        <Route element={<ProtectedLayout />}>
                          <Route path={knowledgeBaseListPage.path} element={<KnowledgebaseListPage />} />
                          <Route path={knowledgeBaseArticlePage.path} element={<KnowledgebaseArticlePage />} />
                          <Route path={guestPage.path} element={<GuestPage />} />
                          <Route path={reservationsPage.path} element={<ReservationsPage />} />
                          <Route path={settingsPage.path} element={<SettingsPage />} />
                          <Route path={paymentsPage.path} element={<PaymentsPage />} />
                          <Route path={reservationTimeTablePage.path} element={<ReservationTimeTablePage />} />
                          <Route path={giftcardPage.path} element={<GiftcardPage />} />
                          <Route path={groupReservationPage.path} element={<GroupReservationPage />} />
                          <Route path={groupReservationEditPage.path} element={<GroupReservationEditPage />} />
                          <Route path={waitlistPage.path} element={<WaitlistPage />} />
                          <Route path={statisticsPage.path} element={<StatisticsPage />} />
                          <Route path={monthlySummary.path} element={<MonthlySummaryPage />} />
                          <Route path={eventReservationsPage.path} element={<EventReservationsPage />} />
                          <Route element={<RoomProvider />}>
                            <Route path={reservationTablePlanPage.path} element={<ReservationTablePlanPage />} />
                            <Route path={floorPlanDesignerPage.path} element={<FloorplanDesignerPage />} />
                          </Route>
                          <Route path={printPage.path} element={<PrintPage />} />
                          <Route path="*" element={<NotFound />} />
                        </Route>
                      </Route>
                    </Routes>
                  </NavBadgeProvider>
                </TitleContext>
              </AuthProvider>
            </SnackbarProvider>
          </GAProvider>
        </FrontendVersionProvider>
      </Suspense>
    </BrowserRouter >
  );
}

export default App;
